module.exports = __webpack_public_path__ + "img/让中国更美丽.96e99b53.png";